import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { IpHolderEditor } from './ip-holder-editor';
import { IpHoldersList } from './ip-holders-list';


export function IpHoldersManagementPage(props: RouteComponentProps) {

    return (<>
        <Route exact
            path={props.match.url} component={IpHoldersList}
        />
        <Route exact
            path={`${props.match.url}/:uid`} component={IpHolderEditor}
        />
    </>);
}
